"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RandomnessManagerFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var RandomnessManagerFactory = /** @class */ (function (_super) {
    __extends(RandomnessManagerFactory, _super);
    function RandomnessManagerFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    RandomnessManagerFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    RandomnessManagerFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    RandomnessManagerFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    RandomnessManagerFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    RandomnessManagerFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return RandomnessManagerFactory;
}(contracts_1.ContractFactory));
exports.RandomnessManagerFactory = RandomnessManagerFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_numberOfBytes',
                type: 'uint256',
            },
        ],
        name: 'getRandomBytes',
        outputs: [
            {
                internalType: 'bytes',
                name: '',
                type: 'bytes',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getRandomBytes32',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
var _bytecode = '0x608060405234801561001057600080fd5b50610229806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c8063ae6dc6fb1461003b578063f5b0fe54146100cd575b600080fd5b6100586004803603602081101561005157600080fd5b50356100e7565b6040805160208082528351818301528351919283929083019185019080838360005b8381101561009257818101518382015260200161007a565b50505050905090810190601f1680156100bf5780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b6100d5610190565b60408051918252519081900360200190f35b60608060005b8381101561018957816100fe610190565b6040516020018083805190602001908083835b6020831061014e57805182527fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe09092019160209182019101610111565b51815160209384036101000a6000190180199092169116179052920193845250604080518085038152939091019052509250506001016100ed565b5092915050565b60008061019b6101ea565b905060005481146101af5760008181556001555b505060018054810190819055600054604080516020808201939093528082019390935280518084038201815260609093019052815191012090565b6000194301409056fea2646970667358221220ee42968d600ed1dd23c3c6da67cfe56f91956ef3327bab0645057223d0d8ada064736f6c63430007040033';
//# sourceMappingURL=RandomnessManagerFactory.js.map